export default "__VITE_ASSET__5e98c0e2__"